import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import AccountsList from './components/AccountsList';
import ActionBar from '../layout/ActionBar';
import AccountDetailTableViewSwitcher from './components/AccountDetailTableViewSwitcher';
import AccountKeysList from './components/AccountKeysList';
import SlidingPane from 'react-sliding-pane';
import DisableKeys from './slideout/DisableKeys';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';
import { useAppSelector } from '../../hooks';

function Accounts() {
  usePageTitle(['Accounts', 'Keys']);
  const currentUser = useAppSelector((state) => state.auth);
  const [reload, setReload] = useState<any>();
  const { t } = useTranslation();
  const [breadcrumb, setBreadcrumb] = useState<{ label: string; link?: string }[]>([
    { label: t('Account details'), link: '/keys/account-details' },
  ]);
  const [grouped, setGrouped] = useLocalStorage<boolean>('accountDetailsGrouped', false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const groupedParam = searchParams.get('grouped');
    if (groupedParam === 'true') {
      setGrouped(true);
    } else if (groupedParam === 'false') {
      setGrouped(false);
    }
  }, [searchParams, setGrouped]);

  useEffect(() => {
    if (searchParams.get('grouped') === null) {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set('grouped', String(grouped));
          return next;
        },
        { replace: true }
      );
    }
  }, [searchParams, grouped, setSearchParams]);

  const handleSetGrouped = (value: boolean) => {
    setGrouped(value);
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set('grouped', String(value));
        return next;
      },
      { replace: true }
    );
  };

  const [itemsChecked, setItemsChecked] = useState<any[]>([]);
  const [disableKeysSlideoutOpen, setDisableKeysSlideoutOpen] = useState(false);
  const [targetRequestAccountDetailIds, setTargetRequestAccountDetailIds] =
    useState<any[]>([]);

  const onDisableKeys = (accounts: any[]) => {
    setTargetRequestAccountDetailIds(accounts.map((x) => x.id));
    setDisableKeysSlideoutOpen(true);
  };

  return (
    <>
      <ActionBar breadcrumb={breadcrumb} />
      {grouped ? (
        <AccountsList
          reload={reload}
          currentUser={currentUser}
          setBreadcrumb={setBreadcrumb}
          itemsChecked={itemsChecked}
          tableViewSwitcher={
            <AccountDetailTableViewSwitcher
              grouped={grouped}
              setGrouped={handleSetGrouped}
              setItemsChecked={setItemsChecked}
            />
          }
        />
      ) : (
        <AccountKeysList
          reload={reload}
          currentUser={currentUser}
          setBreadcrumb={setBreadcrumb}
          itemsChecked={itemsChecked}
          setItemsChecked={setItemsChecked}
          onDisableKeys={onDisableKeys}
          tableViewSwitcher={
            <AccountDetailTableViewSwitcher
              grouped={grouped}
              setGrouped={handleSetGrouped}
              setItemsChecked={setItemsChecked}
            />
          }
        />
      )}
      <SlidingPane
        isOpen={disableKeysSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setDisableKeysSlideoutOpen(false)}
      >
        <DisableKeys
          title={t('Disable keys for multiple accounts')}
          targetKeyRequestAccountDetail={targetRequestAccountDetailIds}
          done={() => {
            setDisableKeysSlideoutOpen(false);
            setReload(new Date());
          }}
          cancel={() => setDisableKeysSlideoutOpen(false)}
          defaultReason={t('Disable keys for multiple accounts')}
        />
      </SlidingPane>
    </>
  );
}

export default Accounts;
